import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Row,
  Col,
  Card,
  CardBody,
  CardText,
  Badge,
  Button
} from 'reactstrap';

import { Tbl, TblHead, TblBody } from '../../components/Tbl';
import FilterPanel from './Filters';
import FilterContainer from '../../components/Container/FilterContainer/FilterContainer';
import { CardHeaderWithToolbars, Title } from '../../components/Card/CardHeaderWithToolbars';
import Toolbars from './Filters/Toolbars';
import DateToHuman from '../../components/DateToHuman';

import { getSubcategoriesList } from '../../actions/subcategoriesAction';
import { getOptionList as getCategoryOptionList } from '../../actions/categoriesAction';
import privateView from '../../components/hocs/privateView';
import Analytics from '../../services/Analytics';

const dataHeader = ['No.', 'Name', 'Parent Category', 'Active', 'Created', 'Updated', 'Action'];

const defaultParams = {
  sort_by: 'updated_at',
  sort_order: 'desc',
  per_page: 15
};

class SubcategoriesIndex extends Component {
  constructor() {
    super();
    this.state = {
      _params: { ...defaultParams },
      _filterOpen: false
    };
    this._handleToggleFilterPanel = this._handleToggleFilterPanel.bind(this);
    this._handleParamsChange = this._handleParamsChange.bind(this);
    this._handleParamsChangeAndSubmit = this._handleParamsChangeAndSubmit.bind(this);
    this._handleRefresh = this._handleRefresh.bind(this);
    this._handleResetFilter = this._handleResetFilter.bind(this);
    this._handleNextPage = this._handleNextPage.bind(this);
    this._handlePrevPage = this._handlePrevPage.bind(this);
  }

  componentDidMount() {
    const { email } = this.props.injectedProps;
    if (!this.props.masterCategories.options.length) {
      this.props.bindCategoryOption();
    }
    this._getList(this.state._params);
    Analytics.recordPageView('subcategory_list', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }

  _toggleFilterPanel() {
    this.setState({ _filterOpen: !this.state._filterOpen });
  }

  _handleToggleFilterPanel(e) {
    e.preventDefault();
    this._toggleFilterPanel();
  }

  _getCategoryName(category_id) {
    const { options } = this.props.masterCategories;
    if (!options.length) return category_id;
    const found = options.find(opt => String(opt.value) === String(category_id));
    return found ? found.label : category_id;
  }

  _onRenderRowItem() {
    const { list } = this.props.masterSubcategories;
    if (list.data && list.data.length > 0) {
      return list.data.map((item, index) => (
        <tr key={item.id}>
          <th scope="row">{index + 1}</th>
          <td>{item.name}</td>
          <td>{this._getCategoryName(item.category_id)}</td>
          <td>
            <Badge color={item.active ? 'success' : 'secondary'}>
              {item.active ? 'Active' : 'Inactive'}
            </Badge>
          </td>
          <td>
            <DateToHuman value={item.created_at} id={`tooltip_createdAt_${index}`} />
          </td>
          <td>
            <DateToHuman value={item.updated_at} id={`tooltip_updatedAt_${index}`} />
          </td>
          <td>
            <Link to={`/subcategories/${item.id}`} className="btn btn-link">Details</Link>
          </td>
        </tr>
      ));
    }
    return null;
  }

  _onRenderPagination() {
    const { list } = this.props.masterSubcategories;
    if (!(list.data && list.data.length > 0)) return null;
    return (
      <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
        <Button
          size="sm"
          color="secondary"
          disabled={!list.prev_cursor}
          onClick={this._handlePrevPage}
        >
          Prev
        </Button>
        <Button
          size="sm"
          color="secondary"
          disabled={!list.next_cursor}
          onClick={this._handleNextPage}
        >
          Next
        </Button>
      </div>
    );
  }

  _handleNextPage() {
    const { next_cursor } = this.props.masterSubcategories.list;
    if (!next_cursor) return;
    const _params = { ...this.state._params, cursor: next_cursor };
    this.setState({ _params }, () => this._getList(this.state._params));
  }

  _handlePrevPage() {
    const { prev_cursor } = this.props.masterSubcategories.list;
    if (!prev_cursor) return;
    const _params = { ...this.state._params, cursor: prev_cursor };
    this.setState({ _params }, () => this._getList(this.state._params));
  }

  _getList(rawParams = {}) {
    let params = {};
    Object.keys(rawParams)
      .filter(key => rawParams[key] !== '')
      .forEach(key => { params[key] = rawParams[key]; });
    this.props.getList({ params });
  }

  _refreshList() {
    const { cursor, ..._params } = this.state._params;
    this.setState({ _params }, () => this._getList(this.state._params));
  }

  _handleParamsChange(e) {
    const { _params } = this.state;
    _params[e.target.name] = e.target.value;
    this.setState({ _params });
  }

  _handleParamsChangeAndSubmit(e) {
    const { cursor, ..._params } = this.state._params;
    _params[e.target.name] = e.target.value;
    this.setState({ _params }, () => this._getList(this.state._params));
  }

  _handleRefresh(e) {
    e.preventDefault();
    this._refreshList();
  }

  _handleResetFilter(e) {
    e.preventDefault();
    const newState = this.state._filterOpen ? { _filterOpen: false } : {};
    this.setState({
      ...newState,
      _params: { ...defaultParams }
    }, () => this._getList(this.state._params));
  }

  render() {
    const { list, isFetch } = this.props.masterSubcategories;
    const hasRow = list.data && list.data.length > 0;
    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs={12}>
            <Card>
              <CardHeaderWithToolbars>
                <Title>
                  <i className="fa fa-align-justify"></i>
                  <span>Subcategory List</span>
                </Title>
                <Toolbars
                  isOpen={this.state._filterOpen}
                  onToggleFilter={this._handleToggleFilterPanel}
                  onRefreshList={this._handleRefresh}
                  onResetFilter={this._handleResetFilter}
                />
              </CardHeaderWithToolbars>
              <FilterContainer>
                <FilterPanel
                  {...this.state._params}
                  categoryOptions={this.props.masterCategories.options}
                  onHandleChange={this._handleParamsChange}
                  onHandleChangeAndSubmit={this._handleParamsChangeAndSubmit}
                  onHandleSearch={this._handleRefresh}
                  isOpen={this.state._filterOpen}
                />
              </FilterContainer>
              <CardBody>
                <CardText>
                  In this section you can manage subcategories for trading cards.
                </CardText>
                <div className="table-responsive">
                  <Tbl>
                    <TblHead dataHeader={dataHeader} />
                    <TblBody
                      isLoad={isFetch}
                      hasRow={hasRow}
                      columnCount={dataHeader.length}
                    >
                      {this._onRenderRowItem()}
                    </TblBody>
                  </Tbl>
                </div>
                {this._onRenderPagination()}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = ({ masterSubcategories, masterCategories, auth: { isFetch, roles, isLogged, id, email } }) => ({
  masterSubcategories,
  masterCategories,
  guardData: { isFetch, roles, isLogged, id, email }
});

const mapDispatchToProps = (dispatch) => ({
  getList: (query) => dispatch(getSubcategoriesList(query)),
  bindCategoryOption: () => dispatch(getCategoryOptionList())
});

const enhance = connect(mapStateToProps, mapDispatchToProps);
export default enhance(privateView(SubcategoriesIndex));
